import React,{ Component, useState, useEffect }  from 'react'
import Modal from "react-modal";
import classNames from "classnames";
import {
  Card,
  CardContent,
  Typography
} from "@mui/material"
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)"
  }
};

const EventAddressModal = ({
  children,
  outerClassNames,
  outerStyle,
  event

}) => {
  const [ modalOpen, setModalOpen ] = useState(false);
  const [ shipping_addresses, setShippingAddresses ] = useState(null);
  const [ loading, setLoading ] = useState(true);

  useEffect(() => {
    fetch(`/webapi/events/${event.id}/shipping_addresses`, {
      method: 'GET',
      redirect: "manual",
    })
      .then(response => {
        return response.json();
      })
      .then(json => {
        setShippingAddresses(json.shipping_addresses)
        setLoading(false)
      })
  }, [
    modalOpen
  ])

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  }

  const renderAddresses = () => {
    if(loading) {
      return <h2 className="text-center"> Loading...</h2>
    }
    if (shipping_addresses) {
      return (
        <div className="flex flex-wrap" >
        {shipping_addresses.map((address) => renderAddress(address))}
        </div>
      )
    }
    return null
  }

  const renderAddress = (address) =>{
    return (
      <div  className="col-xs-12 col-md-6 pb-2 pr-2">
        <Card key={address.id}>
          <CardContent>
            <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
              {address.venue_name}
            </Typography>
            <Typography variant="body2">
              <p>
              <b>Recipient:</b> {[address.first_name, address.last_name].filter(x=>x).join(" ")}
              <br/>
              <b>Phone:</b> {address.phone}
              </p>
              <p>
              <b>Address:</b>
                <br/>
                {[
                  address.address_line_1,
                  address.address_line_2,
                  [address.city, address.state_province, address.postal_code].filter(x=>x).join(", "),
                  address.country
                ].filter(x=>x).map((x,i) => <span key={i}>{x}<br/></span>)}
              </p>
              {address.notes ? <p><b>Notes:</b><br/>{(address.notes||"").split("\n").map((x,i) => <span key={i}>{x}<br/></span>)}</p> : ""}
              {address.shipping_details ? <p><b>Shipping Details:</b><br/>{(address.shipping_details||"").split("\n").map((x,i) => <span key={i}>{x}<br/></span>)}</p> : ""}
            </Typography>
          </CardContent>
        </Card>
      </div>
    )
  }

  return(
    <>
    <div className={`${outerClassNames} mr-8`} style={{...(outerStyle||{}), display: "inline"}} onClick={toggleModal} >
      {children}
    </div>
    <Modal
      className="react-modal item-card-quick-view-modal"
      overlayClassName="react-modal-overlay"
      isOpen={modalOpen}
      onRequestClose={toggleModal}
    >
      <div className="react-modal-close-button" onClick={toggleModal}> &#10005; </div>
      <h1>Addresses</h1>
      {renderAddresses()}
    </Modal>
    </>
  )
}

export default EventAddressModal
